export default "__VITE_ASSET__C3RcmP0e__"